import { createSelector } from 'reselect';
import { activeSelector } from 'selectors/testTarget/offers/freeShippingCopyPDP/active/activeSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const activeFreeShippingCopyPDPSelector = createSelector(isTestTargetReadySelector, activeSelector, (testReady, active) => testReady && active);

export { activeFreeShippingCopyPDPSelector };
